import { marked } from 'marked';

const MarkdownText = ({ text }: { text?: string }) => {
  return (
    <div
      className='wysiwyg-section blue-links'
      dangerouslySetInnerHTML={{
        __html: marked(text?.replace(/\\n/g, '\n') ?? ''),
      }}
    />
  );
};

export default MarkdownText;
